<template>
	<div class="cco-shippingProgress">
		<div class="header" @click="isOpen = !isOpen">
			<div class="header__top">
				<span class="description" v-html="cart.progress.heading"> </span>
				<ArrowIcon :class="{ open: isOpen }"></ArrowIcon>
			</div>
			<div class="header__progress">
				<div class="bar" v-for="item in cart.progress.items">
					<div class="bar--progress" :style="{ width: item.percent }"></div>
				</div>
			</div>
		</div>
		<div
			class="container"
			:class="{ 'container--expanded': isOpen, 'container--closed': !isOpen }"
		>
			<div class="content">
				<div
					class="content__item"
					v-for="item in cart.progress.items"
					:class="[
						{ complete: item.complete },
						{ current: item.current },
						{ ignore: item.ignore },
						item.type,
					]"
				>
					<CheckmarkIcon v-if="item.complete" />
					<span v-else class="square"></span>
					<span v-html="item.description"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as map from "@/vue/mixins/map";

import ArrowIcon from "@web/assets/icon/arrow.svg";
import CheckmarkIcon from "@web/assets/icon/checkmark.svg";
import EllipseIcon from "@web/assets/icon/ellipse.svg";

export default {
	name: "ShippingProgress",
	mixins: [map.cart, map.site],
	components: {
		ArrowIcon,
		EllipseIcon,
		CheckmarkIcon,
	},
	data: () => {
		return {
			isOpen: false,
		};
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-shippingProgress {
	.header {
		cursor: pointer;
		&__top {
			display: flex;
			align-items: center;
			justify-content: space-between;

			svg {
				width: 24px;
				transform: rotate(180deg);
			}

			.open {
				transform: rotate(0deg);
			}
		}

		&__progress {
			display: flex;
			height: 8px;
			margin-top: 13px;
			margin-bottom: 5px;
			gap: 3px;

			.bar {
				display: flex;
				height: 100%;
				flex: 1;
				border-radius: 3px;
				background-color: rgba($c-blue, 0.1);
				transition: 200ms ease-out;
				overflow: hidden;

				&:first-child {
					flex: 3;
				}

				&--progress {
					background-color: $c-green;
				}
			}
		}
	}

	.container {
		overflow: hidden;
		display: grid;
		transition: grid-template-rows 0.3s ease-out;
		grid-template-rows: 0fr;

		&--expanded {
			grid-template-rows: 1fr;
		}

		&--closed {
			grid-template-rows: 0fr;
		}

		.content {
			overflow: hidden;
			min-height: 0;

			&__item {
				opacity: 0.3;
				display: flex;
				align-items: center;
				gap: 8px;

				svg {
					display: flex;
					align-items: center;
					width: 10px;
				}

				.square {
					width: 10px;
					height: 10px;
					border: 1px solid $c-blue;
					border-radius: 5px;
				}

				&.complete {
					opacity: 1;

					&.c:has(~ .ignore) {
						text-decoration: line-through;
						svg {
							opacity: 0;
						}
					}
				}

				&.current {
					opacity: 0.8;
					.square {
						opacity: 0.5;
					}
				}

				&:last-child {
					padding-bottom: 0.5em;
				}
			}
		}
	}
}
</style>
